import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import sf from "../../assets/scss/common/searchFilter.module.scss";

interface SearchOptionProps {
  searchText?: any;
  onSearch: (searchText: any) => void | Promise<void>;
  placeholder?: string | null;
  className?: string;
}

const CommonSearch: React.FC<SearchOptionProps> = ({
  searchText,
  onSearch,
  placeholder = "Search...",
  className = "",
}) => {
  const [searchInput, setSearchInput] = useState<string>("");
  const [searchFocused, setSearchFocused] = useState(false);

  // Synchronize internal search input with prop
  useEffect(() => {
    setSearchInput(searchText || "");
  }, [searchText]);

  // ==============================
  // 🔥 Debounce Search
  // ==============================
  useEffect(() => {
    const handler = setTimeout(() => {
      onSearch(searchInput || null);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInput]);

  // ==============================
  // Handlers
  // ==============================
  const handleSearchChange = (val: string) => {
    setSearchInput(val);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const value = searchInput;
    // Prevent leading space
    if (e.key === " " && value.length === 0) {
      e.preventDefault();
    }
    // Prevent multiple consecutive spaces
    if (e.key === " " && value.endsWith(" ")) {
      e.preventDefault();
    }
  };

  return (
    <Row className={`align-items-center g-2 ${className}`}>
      {/* Search Box */}
      <Col xs="auto">
        <div className={`${sf.searchBox} ${searchFocused ? sf.focused : ""}`}>
          <i className={`ri-search-line ${sf.searchIcon}`} />
          <input
            type="text"
            placeholder={placeholder || "Search..."}
            value={searchInput}
            className={sf.searchInput}
            onChange={(e) => handleSearchChange(e.target.value)}
            onKeyDown={handleKeyDown}
            onFocus={() => setSearchFocused(true)}
            onBlur={() => setSearchFocused(false)}
          />
          {searchInput && (
            <i
              className={`ri-close-line ${sf.clearIcon}`}
              onClick={() => handleSearchChange("")}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default CommonSearch;
